<template>
    <a-box color="blue"></a-box>
</template>

<script>
export default {
    name: "BlueBox"
}
</script>

<style scoped>

</style>